import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {App, Keyboard, NavController, NavParams, Platform, TextInput, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TAcessoFind, TAction, TProdutoTipo, TFinanceSide, TPaybookTipo, TPaybookFato, TProfileTeam, TUsuarioRole, TPaybookModo, TProfileAlma, TConviteTipo, TDevicerScan} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {HotspotService} from "../../../providers/hotspot-service";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {CashierMenuPage} from "../cashier-menu/cashier-menu";
import {PaybookMenuPage} from "../paybook-menu/paybook-menu";
import {WebstorService} from "../../../providers/webstor-service";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {PublicoMenuPage} from "../publico-menu/publico-menu";
import {SpotdayListPage} from "../spotday-list/spotday-list";
import {VoucherInfoPage} from '../voucher-info/voucher-info';
import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {MessageService} from '../../../providers/message-service';
import {StorageService} from '../../../providers/storage-service';
import {DataService} from '../../../providers/data-service';

@Component({
    selector: 'page-hotspot-work',
    templateUrl: 'hotspot-work.html',
    providers: [WebstorService, HotspotService, ProfileService, ProfileRepository]
})
export class HotspotWorkPage {

    TUsuarioRole: any = TUsuarioRole;
    TProfileAlma: any = TProfileAlma;
    
    config: any;
    logado: any;
    rootile: any;

    etapa: number;

    meritums: any;
    consulta: any;
    tecladoText: string;

    codeday: string;

    visitarBool: boolean = false;
    keyboardType: string = 'text';
    keyboardLoop: boolean;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;
    monitorBool: boolean = true;

    heightMini = (window.innerHeight < 700);
    hardwareNfc = (window as any).handappMainInstance.escutarBool && window.innerHeight >= 700;

    @ViewChild('inputCheckin') inputCheckin: TextInput;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams,
                public util: Util, private keyboard: Keyboard,
                public app: App,
                public platform: Platform,
                public dataService: DataService, public storageService: StorageService,
                public messageService: MessageService,
                public webstorService: WebstorService, public hotspotService: HotspotService,
                public logadoService: LogadoService, public profileService: ProfileService, public profileRepository: ProfileRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');

        this.meritums = this.navParams.get('meritums');

        this.etapa = this.navParams.get('etapa');
        this.tecladoText = '';

        this.bmaskerMask();

        this.escutarNear();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Hotspot Work', '/hotspot-work');

    }

    ionViewDidEnter() {

        let color = (this.monitorAuth ? this.monitorAuth.Hotspot.Branded.BrandedCora : 'CorRoxa');
        this.util.statusBarColor(TStatusBar.sbStyleLightContent, false, color);

        setTimeout(() => {
            if (this.inputCheckin) this.inputCheckin.setFocus();
        }, 500);

    }

    getTitle() {

        if (this.heightMini && this.monitorAuth) return (this.tecladoText ? this.tecladoText : this.monitorAuth.Hotspot.Branded.BrandedShow);

        return '';

    }

    navctrlSync(): boolean {

        //#MonitorAuth - Login diretona rede local
        return (this.app.getRootNavs()[0] && this.app.getRootNavs()[0].getActiveChildNavs()[0]);
        //let parentNavCtrl: Tab = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs()[0];

    }

    navctrlBool(platform) {
    
        let platformBool =  this.platform.is(platform);

        return (this.navctrlSync() && platformBool && this.util.nativeApp());

    }

    promotoria() {

        let object = {etapa: 0, flagstor: false, rootile: this.rootile};
        this.util.navActive(this.navCtrl).push(SpotdayListPage, object);

    }

    voucherTest() {

        let objectData = {etapa: 2, voucherID: 0, profileID: 0, hotspotID: this.monitorAuth.Hotspot.HotspotID};
        this.util.modalopen(VoucherInfoPage, 'alto', false, objectData).subscribe();

    }


    /** ************************************************ WEBSTOR ************************************************** **/
    /** ************************************************ etapa-0 ************************************************** **/

    workingHoje() {

        if (this.logado.Profile.ProfileTeam < TProfileTeam.mkManager) return;

        let onPick = (data) => {

            let onGoin = (hotspot) => {
                this.tecladoText = hotspot.Branded.BrandedNick + '-' + hotspot.HotspotCode;
                this.bmaskerOpen();
            };
    
            let buttons: Array<any> = [];
            data.Hotspots.forEach(hotspot => buttons.push({text: hotspot.Branded.BrandedShow, value: hotspot}));
    
            let columns = [];
            columns.push({name: 'root', options: buttons});
            columns[0].selectedIndex = 0;
            this.util.pickerOpen(columns, onGoin);
    
        };

        let loading = this.util.loadingDots();
        if (open) loading.present();

        this.hotspotService.hotspot(TAction.acFake, 0, this.logado.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPick(data),
                erro => this.util.alertResult(erro)
            );

    }

    settingMenu() {

        //#DISABLE

    }

    hotspotAuth(codeday, codeadd) {

        let onDone = (data, text) => {

            this.tecladoText = '';
            this.codeday = codeday;
            this.monitorAuth = data;
            this.akkjson.hotwork = data;

            this.util.toastSimply(text);

            setTimeout(() => {
                if (this.inputCheckin) this.inputCheckin.setFocus();
            }, 800);

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.webstor(TAction.acWork, this.rootile.Profile.ProfileID, 0, codeday, codeadd)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    if (data.Action == '#USERDONE#') onDone(null, 'Não autorizado o login!');
                    if (data.Action == '#USERAUTH#') onDone(data, null);
                    if (data.Action == '#USERWORK#') onDone(data, null);
                },
                erro => onDone(null, erro.Result)
            )

    }

    usuarioLixo() {

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.usuario(TAction.acLixo, this.monitorAuth.Hotspot.HotspotID, this.rootile.Profile.ProfileID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        this.monitorAuth = null;
                        this.akkjson.hotwork = null;
                        this.tecladoText = '';
                    },
                    erro => this.util.alertResult(erro)
                );

        };

        let alerta = 'Sua <b>socilitação será cancelada</b>.';
        this.util.alertQuestion('ATENÇÃO', alerta, 'Eu CONFIRMO', () => onLixo(), false, true);

    }

    bmaskerMask() {

        let text = (this.tecladoText || '');
        let rnid = (text && !isNaN(Number(text[0])));
        let size = text.replace('.', '').length;
        let mask = (size <= 4 ? '0000' : (size == 5 ? '00.000' : '000.000.000-00'));
        let tipo = 'num';

        //Aceita digitação de Workday
        if (!this.monitorAuth && !rnid) {
            let mesk = '';
            let bool = false;
            for (let index = 0; index <= text.length-1; index++) {
                if (text[index] != '-' && isNaN(Number(text[index]))) mesk += 'A';
                if (!isNaN(Number(text[index]))) {
                    bool = true;
                    break;
                }
            }
            mesk = mesk + '-000';
            mask = (bool ? mesk : 'AAAAAAAAAA');
            tipo = 'all';
        }

        return {mask: mask, type: tipo, len: mask.length};

    }

    bmaskerOpen() {

        //#GAMBI - Cardapio do Lorean Desk
        //if (this.monitorAuth && this.monitorAuth.Hotspot.HotspotDesk) return;

        if (this.keyboardLoop) return;

        this.tecladoText = (this.tecladoText || '').toUpperCase();

        let array = this.tecladoText.split('-');
        let nick = (array[0] || '');
        let code = (array[1] || '');
        let work = (nick.length >= 3 && code.length == 3 && !this.monitorAuth);
        let rnid = (this.util.validaCNPF(this.tecladoText) && !this.monitorAuth);
        if (!rnid && !work) return;
      
        this.keyboardLoop = true;
        let texto = this.tecladoText;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            this.keyboardLoop = false;

            if (work) {
                this.consulta = null;
                this.hotspotAuth(texto, true);
                return;
            }

            if (rnid) {
                if (!this.monitorAuth && !this.meritums.length) {
                    this.util.toastSimply('Pegue o Código com o Gerente!');
                    return;
                }

                let onBook = () => {
                    let desk = (this.monitorAuth && this.monitorAuth.Hotspot.HotspotDesk); //#GAMBI
                    if (!desk) this.paybookFind(texto);
                    if ( desk) this.comandaFind();
                };

                /** OPEN **/
                let buttons: Array<any> = [];
                if (this.monitorAuth)                           buttons.push({text: 'Checkin', handler: () => onBook()});
                if (this.meritums) this.meritums.forEach(mr =>  buttons.push({text: mr.MeritumNome, handler: () => this.meritumOpen(mr.MeritumID, texto)}));
                if (this.meritums && this.meritums.length)      buttons.push({text: 'Cancelar', role: 'cancel', cssClass: this.util.sheetClass(true, true, 'food'), handler: () => this.tecladoText = ''});
                this.util.sheetOpen(buttons, 'MERITUM');
            }

        });

    }

    tecladoOkey(btn) {

        this.tecladoText = this.tecladoText.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
        this.tecladoText = this.tecladoText.replace('.', '').replace('.', '').replace('.', '').replace('.', '');

        if (btn == 'ok') {
            this.comandaFind();
        }

        else if (btn == 'cancel') {
            //
        }

        else if (btn == 'erase') {
            this.tecladoText = this.tecladoText.substring(0, this.tecladoText.length-1);
        }

        else if (btn == 'left-thin') {
            this.tecladoText = this.tecladoText+''.slice(0, this.tecladoText.length-1);
        }

        else if (btn == 'dot') {
            //
        }

        else {
            this.tecladoText = this.tecladoText + btn;
        }

        let tecladoText = this.tecladoText;
        if (tecladoText.length <= 4) this.tecladoText = tecladoText;
        if (tecladoText.length == 5) this.tecladoText = tecladoText[0] + tecladoText[1] + '.' + tecladoText[2] + tecladoText[3] + tecladoText[4];
        if (tecladoText.length >= 6) this.tecladoText = tecladoText[0] + tecladoText[1] + tecladoText[2] + '.' + tecladoText[3] + tecladoText[4] + (tecladoText[5] || '') + (tecladoText[6] ? '.' + tecladoText[6] : '') + (tecladoText[7] || '') + (tecladoText[8] || '') + (tecladoText[9] ? '-' + tecladoText[9] : '')  + (tecladoText[10] || '');

    }

    consultando() {

        let meritumID = ( this.consulta.MeritumID);
        let paybookID = (!this.consulta.MeritumID && !this.consulta.ComandaID && this.consulta.PaybookID);
        let comandaID = (!this.consulta.MeritumID && this.consulta.ComandaID);

        if (meritumID) this.meritumOpen(this.consulta.MeritumID, this.consulta.Profile.ProfileRnid);
        if (paybookID) this.paybookLoad(this.consulta.PaybookID, this.consulta.Profile, null, null);
        if (comandaID) this.comandaFind(null, comandaID);

    }

    workjobMenu() {

    }

    meritumOpen(meritumID, rnid) {

        this.tecladoText = '';

        this.consulta = {MeritumID: meritumID, PaybookID: 0, ComandaID: 0, Profile: {ProfileRnid: rnid}};
        let object = {etapa: 4, rootile: this.rootile, meritums: [this.consulta], produtoTipo: TProdutoTipo.ptCard, textfind: rnid};

        this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe(
            data => {
                if (data.deleted) this.consulta = null;
            });

    }

    paybookFind(rnid) {

        this.tecladoText = '';

        let onFind = (data) => {
            let userset = (data.Usuarios || [])[0];
            let profile = (data.Profiles || [])[0];
            let paybook = (data.Paybooks || [])[0];
            let paybookID = (paybook ? paybook.PaybookID : 0);
            if (paybook)                       this.paybookLoad(paybookID, profile, paybook, userset);
            if (!paybook && data.Profiles[0])  this.entrakiOpen(data.Profiles[0]);
            if (!paybook && !data.Profiles[0]) this.clienteFind(rnid);
        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ProfileRnid=' + rnid + '&HotspotID=' + this.monitorAuth.Hotspot.HotspotID + '&PaybookBase=' + 'CURRENT_TIMESTAMP';
        this.profileService.profile(TAction.acGoin, 0, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onFind(data),
                erro => this.util.alertResult(erro)
            );

    }

    entrakiOpen(profile) {

        let onOpen = (paytipo: TPaybookTipo) => {

            let paycria = {
                HotspotID: this.monitorAuth.Hotspot.HotspotID,
                ContratID: 0,
                Branded: this.monitorAuth.Hotspot.Branded,
                Promote: null,
                Projeto: {ProjetoID: 1000, ProjetoNome: 'Fake'},
                Profile: profile,

                PaybookID: 0,
                PaybookSide: TFinanceSide.cdCredito,
                PaybookFato: TPaybookFato.ctVencer,
                PaybookTipo: paytipo,
                PaybookModo: TPaybookModo.pmNone,
                PaybookNoro: 0,
                PaybookHide: false,
                PaybookParc: 0,
                PaybookBase: this.util.dateToStr(null, false),
                PaybookCria: this.util.dateToStr(null, true),
                PaybookBora: '',
                PaybookText: '',

                Consumos: [],
                Parcelas: [],
                Invoices: [],
            };

            let object = {etapa: 1, profileDesk: profile, paybook: paycria, spotdayID: 0, paybookTipo: paytipo};
            this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
                .subscribe(data => this.consulta = {MeritumID: 0, PaybookID: data.PaybookID, ComandaID: 0, Profile: profile});

        };


        let onMoto = () => {

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Entrega', handler: () => onOpen(TPaybookTipo.pbSend)});
            buttons.push({text: 'Retirar', handler: () => onOpen(TPaybookTipo.pbTake)});
            this.util.sheetOpen(buttons, 'PAYBOOK');

        };

        /** OPEN **/
        let sale = this.monitorAuth.Hotspot.SettingSale;
        let pedy = this.monitorAuth.Hotspot.SettingPedy;
        let buttons: Array<any> = [];
        buttons.push({text: 'Checkin',  handler: () => onOpen(TPaybookTipo.pbCard)});
        if (pedy) buttons.push({text: 'Pedido', handler: () => onMoto()});
      //if (sale) buttons.push({text: 'Vender', handler: () => onSale()});
        this.util.sheetOpen(buttons, 'PAYBOOK');

    }

    clienteFind(rnid) {

        let ghosterID = this.monitorAuth.Hotspot.Branded.BrandedID;
        this.profileRepository.profileFind(rnid, 'CPF', ProfileMenuPage, ghosterID)
            .subscribe(line => this.entrakiOpen(line));

    }

    publicoList() {

        let hotspot = this.monitorAuth.Hotspot;
        let userset = this.monitorAuth.Usuarios[0];

        let object = {etapa: 0, userset: userset, monitorBool: this.monitorBool, rootile: this.rootile, hotspotID: hotspot.HotspotID, paybookBase: 'CURRENT_TIMESTAMP', paybookFull: true, branded: hotspot.Branded};
        this.util.navActive(this.navCtrl).push(PublicoMenuPage, object, {animation: 'md-transition'});

    }

    cashierMenu() {

        //this.monitorAuth.Cashier.CashierID
        let object = {etapa: 0, perfil: this.rootile, cashierID: 0};
        this.util.navActive(this.navCtrl).push(CashierMenuPage, object);

    }

    workdayDone() {

        this.tecladoText = '';
        this.consulta = null;

        //LOCAL-SERVER não limpa ao voltar para tela de login!
        let bool = this.dataService.get('MONITOR-AUTH');
        if (!bool) {
            this.monitorAuth = null;
            this.akkjson.hotwork = null;
        }
        
        this.dataService.set('MESAFIX-FIXA', null);

        //#MonitorAuth - Login diretona rede local
        if (!this.navctrlSync()) {
            this.logadoService.logout()
            this.dismiss();
        }

    }





    comandaExit(paybook) {

        if (!paybook) return;
        let hotspotID = paybook.HotspotID;

        let onExit = (root) => {
            paybook.Outbook = root.Comandas[0].Outbook;
            this.util.impact();

            let onThen = () => {};//this.navCtrl.getPrevious().dismiss();
            let object = {etapa: 3, paybook: paybook};
            this.util.modalopen(EntrakiOpenPage, 'alto', false, object, null, null, null, onThen).subscribe();
        };

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&ComandaID=' + paybook.ComandaID;
        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', hotspotID, params, TAction.acExit)
            .finally(() => loading.dismiss())
            .subscribe(
                root => onExit(root),
                erro => this.util.alertResult(erro));

    }

    paybookLoad(paybookID, profile, paybook, userset) {

        let procopy = this.util.deepCopy(profile);
        this.consulta = {MeritumID: 0, PaybookID: paybookID, ComandaID: 0, Profile: procopy};

        if (!userset) userset = this.monitorAuth.Usuarios[0];

        let exiting =

        // userset.UsuarioOlhe ||

        //Money
        // userset.UsuarioCoin ||
        // userset.UsuarioGera ||
        // userset.UsuarioNota ||
        // userset.UsuarioBank ||

        //Price
        // userset.UsuarioMenu ||
        // userset.UsuarioStok ||
        // userset.UsuarioItem ||
        // //userset.UsuarioRoad ||
        // userset.UsuarioFoto ||
        // userset.UsuarioMark ||
        // userset.UsuarioCard ||
        // userset.UsuarioSeal ||

        //Venda
        userset.UsuarioSale ||
        userset.UsuarioGorj ||
        userset.UsuarioMove ||
        userset.UsuarioDisc ||
        
        //Stock
        userset.UsuarioRepo ||
        userset.UsuarioCanc ||

        //Caixa
        userset.UsuarioCaxa ||
        userset.UsuarioDesp ||
        userset.UsuarioEsto ||
        userset.UsuarioBlod ||

        //Porta
        userset.UsuarioGoin ||
      //userset.UsuarioSair
        userset.UsuarioDoor ||

        //Perfil
        userset.UsuarioMemo ||
        userset.UsuarioLock ||
        userset.UsuarioPend;

        if (!exiting && userset.UsuarioSair) {
            this.comandaExit(paybook);
            return;
        }



        //Para não carregar na proxima tela!
        if (paybook) paybookID = 0;
        let branded = (paybook || this.monitorAuth.Hotspot || {}).Branded;

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;

        let object = {etapa: 0, olhaapp: false, monitorBool: this.monitorBool, fronter: false, profile: profile, branded: branded, workday: true, userset: userset, paybookID: paybookID, paybook: paybook, hotspotID: hotspotID};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    monitorDesk() {

        this.monitorBool = !this.monitorBool;

    }

    comandaCria(tecladoText, userset, paybookTipo: TPaybookTipo, paybookModo: TPaybookModo, lino) {

        if (lino) lino.ProfileRnid = tecladoText;
        
        let checkinNoro = (lino ? 0 : parseInt((tecladoText+'').replace('.', '')));
                
        let hotspot = this.monitorAuth.Hotspot;

        let object = {etapa: 1, monitorBool: this.monitorBool, hotspot: hotspot, userset: userset, profileDesk: lino, checkinNoro: checkinNoro, spotdayID: 0, paybookTipo: paybookTipo, paybookModo: TPaybookModo.pmUser, checkinSelf: false, conviteTipo: TConviteTipo.ctConvitePorta};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object)
            .subscribe(done => {
                this.consulta = {MeritumID: 0, PaybookID: 0, ComandaID: done.PaybookID, Profile: lino};
                if (paybookTipo == TPaybookTipo.pbCard && !lino) this.consulta.Profile = {ProfileID: 1, ProfileShow: 'Visitante'};
                if (paybookTipo == TPaybookTipo.pbMesa) this.comandaFind(null, done.PaybookID);
            });

    }

    comandaInit(tecladoText, userset, paybookTipo: TPaybookTipo, paybookModo: TPaybookModo) {

        if (!this.util.validaCNPF(tecladoText)) return;
        tecladoText = this.util.formatDOC(tecladoText);

        let ghosterID = this.monitorAuth.Hotspot.Branded.BrandedID;
        this.profileRepository.profileFind(tecladoText, 'CPF', ProfileMenuPage, ghosterID, false, false, null, this.monitorBool).subscribe(
            lino => this.comandaCria(tecladoText, userset, paybookTipo, paybookModo, lino));

    }


    comandaFind(profileRnid?, comandaID?, paybookModo: TPaybookModo = TPaybookModo.pmUser) {

        let textfind = (comandaID ? comandaID : (profileRnid ? profileRnid : this.tecladoText));

        //ZERO - Tira os zeros para identificar se digitou comanda comecando com 0085 e não digitou CPF
        if (textfind.length <= 6 && textfind == this.tecladoText) {
            textfind = textfind.replace('-', '').replace('-', '').replace('-', '').replace('-', '');
            textfind = textfind.replace('.', '').replace('.', '').replace('.', '').replace('.', '');    
            textfind = parseInt(textfind || '0')+'';
        }

        let hotspotID = this.monitorAuth.Hotspot.HotspotID;
        let profileBool = (this.util.validaCNPF(textfind+''));
        let comandaTipo = (textfind.length < 4 ? TPaybookTipo.pbMesa : TPaybookTipo.pbCard);

        let onPush = (data) => {

            if (data.Hotspot) this.util.populateObj(this.monitorAuth.Hotspot, data.Hotspot);

            let userset = (data.Usuarios || [])[0];
            let paybook = (data.Comandas || [])[0];
            let profile = (paybook || {}).Profile;
            let paybookID = (paybook ? paybook.PaybookID : 0);
            
            profileBool = (profileBool && this.monitorAuth.Hotspot.SettingCard && userset && userset.UsuarioGoin);
            let newmesa = (textfind.length < 4  && this.monitorAuth.Hotspot.SettingMesa && this.monitorAuth.Hotspot.SettingAlma == TProfileAlma.paLancaki);
            let newcard = (textfind.length >= 4 && this.monitorAuth.Hotspot.SettingCard && this.monitorAuth.Hotspot.SettingAlma == TProfileAlma.paCheckin && userset && userset.UsuarioGoin && this.visitarBool);
            let paycria = !comandaID && (profileBool || newmesa  || newcard);

            if ( paybook)                             this.paybookLoad(paybookID, profile, paybook, userset);
            if (!paybook &&  profileBool            ) this.comandaInit(textfind, userset, comandaTipo, paybookModo);
            if (!paybook && !profileBool &&  paycria) this.comandaCria(textfind, userset, comandaTipo, paybookModo, null);
            if (!paybook && !profileBool && !paycria) this.util.toastSimply('Não encontrado');
            this.tecladoText = '';
            this.visitarBool = false;

        };

        let loading = this.util.loadingDots();
        loading.present();

        //#HIDE -> EXCLUIR REQUEST E ABRIR EntrakiOpenPage PEDINDO AMBIENTE E CONVITE
        let ambientGamb = {AmbientID: 0, AmbientNome: ''};
        let voucherNovo = {Ambient: ambientGamb, VoucherSeco: 0, VoucherSuga: 0, VoucherZera: 0, VoucherGorj: 0};
        let params = '&ComandaText=' + textfind +
                     '&ComandaMode=' + (comandaID ? TAcessoFind.afFindID : (profileBool ? TAcessoFind.afFindRnid : TAcessoFind.afFindNoro));

        this.util.monitorDesk(this.monitorBool, 'DESK-Comanda', hotspotID, params, TAction.acFind, voucherNovo, 3000)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onPush(data),
                erro => this.util.alertResult(erro, () => this.tecladoText = ''));

    }






    escutaScan() {

        (window as any).handappMainInstance.escutarScan();

    }

    escutarNear() {

        this.messageService.get(TDevicerScan[TDevicerScan.dsWorkday]).subscribe(
            data => {

                // TELA-DISPONIVEL - ADM | HOTSPOT-NOT | COMANDAVIEW | PROFILECRIA -> não faz nada!
                //SHERIFF - if (this.util.websterPage == 1 || !this.monitorAuth) return;

                //console.log(json);
                let json = this.util.jsParse(data);
                if (!json) {
                    this.util.alertSimply(data, 'JSON ERROR');
                    return;
                }

                //comandaScan - Enter
                if (json.ComandaNoro) {
                    this.tecladoText = json.ComandaNoro+'';
                    this.comandaFind(null, null, TPaybookModo.pmNear);
                    //this.processScan(TPaybookModo.pmNear, data);
                }

            }
        );

    }



    dismiss() {

        //SÓ USA COM...
        //#MonitorAuth - Login diretona rede local
        this.navCtrl.pop({animate: false});

    }


}



// WEBPACK FOOTER //
// ./src/pages/sync/hotspot-work/hotspot-work.ts